// What `/login` shows for the router's `?error=` (and `error_description`).
//
// The router sends `email_unverified` when WorkOS has not verified the email
// address of the sign-in, and a profile with that address exists (router#1768,
// RS-5): the router does not link the sign-in to that profile. The code alone
// does not tell the user what to do, so the app says it (app#377).
//
// ⚠ A Map, not an object literal: the code comes from a link anybody can make, and
// `?error=__proto__` or `?error=constructor` would read the object's prototype. That
// value is not a string, and React then fails to render the sign-in page.
const MESSAGES = new Map<string, string>([
  ['email_unverified', 'Your email address is not verified. Verify it, then sign in again.'],
  // The app's own email sign-in (router auth/email_signin.go).
  ['invalid_code', 'That code is not correct, or it expired. Check the email, or send a new code.'],
  ['invalid_password', 'The email address or the password is not correct.'],
  ['too_many_attempts', 'Too many attempts. Wait a few minutes, then try again.'],
  ['invalid_request', 'Enter your email address, then a code or a password.'],
  // The router's other sign-in failures (auth/provider.go, auth/sso.go).
  ['sso_required', 'Your organization requires single sign-on (SSO). Sign in through your organization.'],
  ['missing_code', 'The sign-in did not finish. Try again.'],
  ['workos_auth_failed', 'The sign-in did not finish. Try again.'],
  ['session_error', 'The sign-in could not start a session. Wait a moment, then try again.'],
  ['user_error', 'Your account could not be loaded. Try again.'],
  ['identity_error', 'Your account could not be loaded. Try again.'],
])

const FALLBACK = 'The sign-in did not finish. Try again.'

// The query string is decoded already. A second decode of a value with a bare `%`
// throws, so the raw value is shown then.
const decodeOnce = (value: string): string => {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const signInErrorMessage = (error: string | null, description: string | null): string | null => {
  if (!error) return null
  const known = MESSAGES.get(error)
  if (known) return known
  return description ? decodeOnce(description) : FALLBACK
}
